import React from 'react'
import { Card, CardContent, Typography } from '@mui/material'

interface KeyFindingCardProps {
  statement: string
  context: string
  sourceAttribution: string
}

const KeyFindingCard: React.FC<KeyFindingCardProps> = ({
  statement,
  context,
  sourceAttribution,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderLeft: 4,
        borderLeftColor: 'secondary.main',
      }}
    >
      <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, color: 'primary.main', mb: 1 }}
        >
          {statement}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 2, flex: 1 }}
        >
          {context}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {sourceAttribution}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default KeyFindingCard
